import * as XLSX from 'xlsx';
import { StudentData } from '../types';

export function generateEnrichedExcel(studentDataList: StudentData[]): ArrayBuffer {
  const workbook = XLSX.utils.book_new();

  const headers = [
    '学号',
    '姓名',
    '班级',
    '组别',
    'Q1参与',
    'Q2意志',
    'Q3认知',
    'Q4提升',
    'Q5安全',
    'Q6准备',
    'Q7守序',
    'Q8激励',
    '综合评价',
    '互评Q1',
    '互评Q2',
    '互评Q3',
    '互评Q4',
    '师评Q1',
    '师评Q2',
    '师评Q3',
    '师评Q4',
    '微观评语',
  ];

  const rows = studentDataList.map((data) => [
    data.student.studentId.split('_')[1] || '',
    data.student.studentName,
    data.student.className,
    data.student.groupId,
    data.selfEval.q1Participation,
    data.selfEval.q2Resilience,
    data.selfEval.q3SkillKnow,
    data.selfEval.q4SkillImprove,
    data.selfEval.q5HealthSafe,
    data.selfEval.q6HealthPrep,
    data.selfEval.q7MoralQueue,
    data.selfEval.q8MoralEncourage,
    data.selfEval.overallEval,
    data.peerEval?.q1Emotion ?? '',
    data.peerEval?.q2Support ?? '',
    data.peerEval?.q3SafeRespect ?? '',
    data.peerEval?.q4Effort ?? '',
    data.teacherGroupEval?.q1Complete ?? '',
    data.teacherGroupEval?.q2Attitude ?? '',
    data.teacherGroupEval?.q3Discipline ?? '',
    data.teacherGroupEval?.q4Atmosphere ?? '',
    data.microReport ?? '',
  ]);

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  XLSX.utils.book_append_sheet(workbook, worksheet, '评价结果');

  return XLSX.write(workbook, { type: 'array', bookType: 'xlsx' }) as unknown as ArrayBuffer;
}